type SkeletonLoaderProps = {
  length: number;
  type: 'property' | 'searchResult';
};

export const SkeletonLoader = ({ length, type }: SkeletonLoaderProps) => {
  if (!type) {
    return null;
  }

  if (type === 'property') {
    return (
      <>
        {Array.from({ length }).map((_, index) => (
          <div
            key={index}
            className="flex flex-row justify-between gap-3 border-b-1 border-solid border-[#E6E6E6] p-4"
          >
            <div className="flex flex-col gap-2">
              <div className="h-5 w-40 animate-pulse rounded-md bg-[#E6E6E6]" />

              <div className="flex flex-row items-center justify-start gap-1">
                <div className="h-4 w-14 animate-pulse rounded-md bg-[#E6E6E6]" />
                <div className="h-1 w-1 animate-pulse rounded-full bg-[#E6E6E6]" />
                <div className="h-4 w-14 animate-pulse rounded-md bg-[#E6E6E6]" />
                <div className="h-1 w-1 animate-pulse rounded-full bg-[#E6E6E6]" />
                <div className="h-4 w-14 animate-pulse rounded-md bg-[#E6E6E6]" />
              </div>
            </div>

            <div className="flex flex-row items-center justify-end gap-3">
              <div className="h-5 w-10 animate-pulse rounded-full bg-[#E6E6E6]" />
              <div className="m-1 h-4 w-4 animate-pulse rounded-md bg-[#E6E6E6]" />
            </div>
          </div>
        ))}
      </>
    );
  }

  if (type === 'searchResult') {
    return (
      <>
        {Array.from({ length }).map((_, index) => (
          <div
            key={index}
            className="rounded-lg-alt flex flex-row justify-between gap-3 border-1 border-solid border-[#E6E6E6] p-4"
          >
            <div className="h-5 w-40 animate-pulse rounded-md bg-[#E6E6E6]" />
          </div>
        ))}
      </>
    );
  }
};
